import React from "react"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view";
import DropdownFormStatelessView from "../../../../generic/dropdown/render/form/components/form-stateless";


export default function FieldProjectAccessMode_FormElementView(props: FieldFormElementViewProps) {

    const value = props.model[props.field.fieldId]

    return <DropdownFormStatelessView className      = {props.className}
                             field          = {props.field}
                             model          = {props.model}
                             value          = {value}
                             configOptions  = {props.options}
                             disabled       = {props.disabled}
                             onChange       = {props.onChange}/>

}